function calculateIngredientsQuantity(wrapper) {
  const quantity = wrapper.find('input[name="quantity"]');
  const initQty = parseInt(quantity.attr('placeholder'), 10);
  const currentQty = parseInt(quantity.val(), 10);

  wrapper.find('[data-recipe-ingredient-quantity]').each((idx, ingredient) => {
    const qty = $(ingredient).attr('data-recipe-ingredient-quantity');
    if (qty) {
      let newQty = (qty / initQty) * currentQty;
      newQty = Number.isInteger(newQty) ? newQty : newQty.toFixed(2);
      $(ingredient).text(newQty);
    }
  });
}

$(document).on('click', '[data-recipe-ingredient-decrement]', function() {
  const wrapper = $(this).closest('[data-recipe-ingredients]');
  const quantity = wrapper.find('input[name="quantity"]');
  let currentQty = parseInt(quantity.val(), 10) - 1;
  if (currentQty <= 0) {
    currentQty = 1;
  }
  quantity.val(currentQty);
  calculateIngredientsQuantity(wrapper);
});

$(document).on('click', '[data-recipe-ingredient-increment]', function() {
  const wrapper = $(this).closest('[data-recipe-ingredients]');
  const quantity = wrapper.find('input[name="quantity"]');
  quantity.val(parseInt(quantity.val(), 10) + 1);
  calculateIngredientsQuantity(wrapper);
});

$(document).on('input', '[data-recipe-ingredients] input[name="quantity"]', function() {
  const quantity = $(this);
  const wrapper = quantity.closest('[data-recipe-ingredients]');
  let currentQty = parseInt(quantity.val(), 10);
  if (currentQty < 0 || Number.isNaN(currentQty)) {
    currentQty = 0;
  }
  quantity.val(currentQty);
  calculateIngredientsQuantity(wrapper);
});

function updateLikes(formData, url, action, likes) {
  let act = action;
  const urlStr = url;
  let cnt = Number(likes);
  if (Number.isNaN(cnt)) cnt = 0;
  if (cnt === 0) {
    act = 'create';
    formData.push({
      name: 'action',
      value: act,
    });
  }
  $.ajax({
    method: 'POST',
    url: urlStr,
    data: formData,
  });
  if (act === 'del') cnt -= 1;
  else cnt += 1;
  if (cnt < 0) cnt = 0;
  return cnt;
}

$(document).ready(() => {
  if ($('[data-page-id]').length > 0) {
    const pageId = $('[data-page-id]')[0].getAttribute('data-page-id');
    const iconId = '#recipe-likes-icon-'.concat(pageId);
    const recipeLikes = localStorage.getItem('likes');
    if (recipeLikes) {
      if (recipeLikes.includes(pageId)) {
        $(iconId).removeClass('icon-heart');
        $(iconId).addClass('icon-heart-fill');
      }
    }
  }
});

$(document).on('submit', '[update-recipe-likes]', function(event) {
  event.preventDefault();
  const $form = $(this);
  const formData = $form.serializeArray();
  const pageId = $form[0].getAttribute('data-page-id');
  const likes = $('#recipe-likes-'.concat(pageId)).val();
  const url = $form[0].getAttribute('action');
  const pageType = $form[0].getAttribute('pageType');

  let likeList = [];
  let cnt = 0;
  if (localStorage.getItem('likes')) {
    likeList = JSON.parse(localStorage.getItem('likes'));
  }

  if (likeList.length > 0) {
    if (!likeList.includes(pageId)) {
      const addlikes = likeList.concat(pageId);
      localStorage.setItem('likes', JSON.stringify(addlikes));
      formData.push({
        name: 'action',
        value: 'add',
      });
      cnt = updateLikes(formData, url, 'add', likes);
      $('#recipe-likes-counter-'.concat(pageId)).text(cnt);
      $('#recipe-likes-'.concat(pageId)).val(cnt);
      if (pageType === 'block') {
        $('#recipe-likes-icon-'.concat(pageId)).removeClass('icon-heart');
        $('#recipe-likes-icon-'.concat(pageId)).addClass('icon-heart-fill');
      } else if (cnt === 0) {
        $('#recipe-likes-icon-'.concat(pageId)).removeClass('icon-heart-fill');
        $('#recipe-likes-icon-'.concat(pageId)).addClass('icon-heart');
      } else {
        $('#recipe-likes-icon-'.concat(pageId)).removeClass('icon-heart');
        $('#recipe-likes-icon-'.concat(pageId)).addClass('icon-heart-fill');
      }
    } else {
      const idx = likeList.indexOf(pageId);
      if (idx > -1) {
        likeList.splice(idx, 1);
      }
      localStorage.setItem('likes', JSON.stringify(likeList));
      formData.push({
        name: 'action',
        value: 'del',
      });
      cnt = updateLikes(formData, url, 'del', likes);
      $('#recipe-likes-counter-'.concat(pageId)).text(cnt);
      $('#recipe-likes-'.concat(pageId)).val(cnt);
      if (pageType === 'block') {
        $('#recipe-likes-icon-'.concat(pageId)).removeClass('icon-heart-fill');
        $('#recipe-likes-icon-'.concat(pageId)).addClass('icon-heart');
      } else if (cnt === 0) {
        $('#recipe-likes-icon-'.concat(pageId)).removeClass('icon-heart-fill');
        $('#recipe-likes-icon-'.concat(pageId)).addClass('icon-heart');
      } else {
        $('#recipe-likes-icon-'.concat(pageId)).removeClass('icon-heart');
        $('#recipe-likes-icon-'.concat(pageId)).addClass('icon-heart-fill');
      }
    }
  } else {
    likeList.push(pageId);
    localStorage.setItem('likes', JSON.stringify(likeList));
    formData.push({
      name: 'action',
      value: 'add',
    });
    cnt = updateLikes(formData, url, 'add', likes);
    $('#recipe-likes-counter-'.concat(pageId)).text(cnt);
    $('#recipe-likes-'.concat(pageId)).val(cnt);
    if (pageType === 'block') {
      $('#recipe-likes-icon-'.concat(pageId)).removeClass('icon-heart');
      $('#recipe-likes-icon-'.concat(pageId)).addClass('icon-heart-fill');
    } else if (cnt === 0) {
      $('#recipe-likes-icon-'.concat(pageId)).removeClass('icon-heart-fill');
      $('#recipe-likes-icon-'.concat(pageId)).addClass('icon-heart');
    } else {
      $('#recipe-likes-icon-'.concat(pageId)).removeClass('icon-heart');
      $('#recipe-likes-icon-'.concat(pageId)).addClass('icon-heart-fill');
    }
  }
});
